import ContactHeroSection from "../companents/Contact/ContactHeroSection/Index";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import Loading from "../companents/shared/Loading/Loading";

const Contact = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Sanki data yüklənirmiş kimi loading göstərmək üçün simulyasiya
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer); // təmizləmə
  }, []);

  return (
    <>
      <Helmet>
        <title>Əlaqə</title>
      </Helmet>

      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <ContactHeroSection />
        </div>
      )}
    </>
  );
};

export default Contact;
